<template>
  <div class="mfooter">
    <div>哈尔滨市物业管理协会</div>
    <div class="mt10">地址：哈尔滨市道里区建安路爱建公寓A座106 电话：0451-87696938</div>
    <div class="mt10">ICP备案编号：黑ICP备17000394</div>
    <div class="mt10">技术支持：哈尔滨万线科技开发有限公司</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    // ...mapGetters(['winScroll']),
  },
  watch: {},
  mounted() {},

  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mfooter {
  padding: 80px 0;
  background: #8aa9f5;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/mFooter.vue